export const createSharedCallback = (
  defaultCallback?: () => void,
): [(callback: (data: any) => void) => void, () => void, (data: any) => void] => {
  const sharedStore: {
    callback: undefined | ((data: any) => void);
    registerCallback: (callback: (data: any) => void) => void;
    unregisterCallback: () => void;
    executeCallback: (data: any) => void;
  } = {
    callback: defaultCallback,
    registerCallback: (callback) => {
      sharedStore.callback = callback;
    },
    unregisterCallback: () => {
      sharedStore.callback = undefined;
    },
    executeCallback: (data) => {
      if (sharedStore.callback) {
        sharedStore.callback(data);
      }
    },
  };

  return [sharedStore.registerCallback, sharedStore.unregisterCallback, sharedStore.executeCallback];
};

export default createSharedCallback;
